// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/fulfillment/pick_pack/v1/packing.proto (package stailer_service_specification.fulfillment.pick_pack.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { enumDesc, fileDesc, messageDesc, tsEnum } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_enum_description } = require("../../../../description_support/v1/enum_description_pb");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/fulfillment/pick_pack/v1/packing.proto.
 */
const file_stailer_service_specification_fulfillment_pick_pack_v1_packing = /*@__PURE__*/
  fileDesc("CkRzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9mdWxmaWxsbWVudC9waWNrX3BhY2svdjEvcGFja2luZy5wcm90bxI2c3RhaWxlcl9zZXJ2aWNlX3NwZWNpZmljYXRpb24uZnVsZmlsbG1lbnQucGlja19wYWNrLnYxIocHCgdQYWNraW5nEugCChRjb250YWluZXJfbGFiZWxfc2l6ZRgEIAEoDjJSLnN0YWlsZXJfc2VydmljZV9zcGVjaWZpY2F0aW9uLmZ1bGZpbGxtZW50LnBpY2tfcGFjay52MS5QYWNraW5nLkNvbnRhaW5lckxhYmVsU2l6ZUL1AZKCGcMB44K544K/44OD44OV44Ki44OX44Oq44Gn44OR44OD44Kt44Oz44Kw44GZ44KL44Go44GN44CB44Kz44Oz44OG44OK77yI566x77yJ44Gr6LK844KL44Op44OZ44Or44Gu5Y2w5Yi344K144Kk44K644Gn44GZ44CC44OX44Oq44Oz44K/44Gr44K744OD44OI44GZ44KL44Op44OZ44Or55So57SZ44Gr5ZCI44KP44Gb44Gm6YG444Gz44G+44GZ44CCoIIZAaqCGSHjgrPjg7Pjg4bjg4rjg6njg5njg6vjga7jgrXjgqTjgrrIghkBEvMBChZzdGFmZl9hcHBfcGFja2luZ19saXN0GAUgASgLMksuc3RhaWxlcl9zZXJ2aWNlX3NwZWNpZmljYXRpb24uZnVsZmlsbG1lbnQucGlja19wYWNrLnYxLlN0YWZmQXBwUGFja2luZ0xpc3RChQGSghlC44K544K/44OD44OV44Ki44OX44Oq44Gu44OR44OD44Kt44Oz44Kw44Oq44K544OI44Gu5LuV5qeY44Gn44GZ44CCoIIZAaqCGTPjgrnjgr/jg4Pjg5XjgqLjg5fjg6rjg5Hjg4Pjgq3jg7PjgrDjg6rjgrnjg4jku5Xmp5jIghkBIpoCChJDb250YWluZXJMYWJlbFNpemUSiAEKIENPTlRBSU5FUl9MQUJFTF9TSVpFX1VOU1BFQ0lGSUVEEAAaYuqCGUvmqJnmupbjgrXjgqTjgrrjga7jg6njg5njg6vvvIjjg5fjg4Hjg6njg5Hjg7PmqJnmupbvvInjgafljbDliLfjgZfjgb7jgZnjgIL6ghkP5qiZ5rqW44K144Kk44K6EnkKGkNPTlRBSU5FUl9MQUJFTF9TSVpFX1NNQUxMEAEaWeqCGUXlsI/jgrXjgqTjgrrjga7jg6njg5njg6vvvIjjg5fjg4Hjg6njg5Hjg7PlsI/vvInjgafljbDliLfjgZfjgb7jgZnjgIL6ghkM5bCP44K144Kk44K6IuEBChNTdGFmZkFwcFBhY2tpbmdMaXN0EskBCh5lbmFibGVfZGlzcGxheWluZ19wcm9kdWN0X2NvZGUYAiABKAhCoAGSghlo44K544K/44OD44OV44Ki44OX44Oq44Gu44OR44OD44Kt44Oz44Kw44Oq44K544OI44GrUHJvZHVjdENvZGXjgpLooajnpLrjgZnjgovloLTlkIjjgavmjIflrprjgZfjgb7jgZnjgIKqghks44K544K/44OD44OV44Ki44OX44Oq44GrUHJvZHVjdENvZGXjgpLooajnpLrIghkBYgZwcm90bzM", [file_description_support_v1_enum_description, file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.fulfillment.pick_pack.v1.Packing.
 * Use `create(PackingSchema)` to create a new message.
 */
const PackingSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_fulfillment_pick_pack_v1_packing, 0);

/**
 * Describes the enum stailer_service_specification.fulfillment.pick_pack.v1.Packing.ContainerLabelSize.
 */
const Packing_ContainerLabelSizeSchema = /*@__PURE__*/
  enumDesc(file_stailer_service_specification_fulfillment_pick_pack_v1_packing, 0, 0);

/**
 * パッキング時に使うコンテナに貼るラベルサイズの指定です。
 *
 * @generated from enum stailer_service_specification.fulfillment.pick_pack.v1.Packing.ContainerLabelSize
 */
const Packing_ContainerLabelSize = /*@__PURE__*/
  tsEnum(Packing_ContainerLabelSizeSchema);

/**
 * Describes the message stailer_service_specification.fulfillment.pick_pack.v1.StaffAppPackingList.
 * Use `create(StaffAppPackingListSchema)` to create a new message.
 */
const StaffAppPackingListSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_fulfillment_pick_pack_v1_packing, 1);


exports.file_stailer_service_specification_fulfillment_pick_pack_v1_packing = file_stailer_service_specification_fulfillment_pick_pack_v1_packing;
exports.PackingSchema = PackingSchema;
exports.Packing_ContainerLabelSizeSchema = Packing_ContainerLabelSizeSchema;
exports.Packing_ContainerLabelSize = Packing_ContainerLabelSize;
exports.StaffAppPackingListSchema = StaffAppPackingListSchema;
